import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("h2", { class: "font-semibold text-xl text-gray-800 leading-tight" }, " 模試編集 ", -1);
const _hoisted_2 = { class: "max-w-7xl mx-auto py-10 sm:px-6 lg:px-8" };
const _hoisted_3 = { class: "shadow-lg bg-white rounded-lg p-6" };
const _hoisted_4 = { class: "grid grid-cols-12" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "title"
}, [
    /*#__PURE__*/ _createTextVNode(" 模試タイトル"),
    /*#__PURE__*/ _createElementVNode("span", { class: "text-red-500" }, "*")
], -1);
const _hoisted_6 = { class: "col-span-8" };
const _hoisted_7 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "is_published"
}, " 公開フラグ ", -1);
const _hoisted_9 = { class: "col-span-8 pt-1.5" };
const _hoisted_10 = { class: "flex items-center" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", {
    for: "is_published",
    class: "text-gray-700"
}, "公開状態を切り替える", -1);
const _hoisted_12 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "reception_start"
}, " 受付開始日時 ", -1);
const _hoisted_14 = { class: "col-span-8 flex" };
const _hoisted_15 = { class: "w-1/2" };
const _hoisted_16 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "reception_end"
}, " 受付終了日時 ", -1);
const _hoisted_18 = { class: "col-span-8" };
const _hoisted_19 = { class: "w-1/2" };
const _hoisted_20 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "start_date"
}, " 試験開始日時 ", -1);
const _hoisted_22 = { class: "col-span-8" };
const _hoisted_23 = { class: "w-1/2" };
const _hoisted_24 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "end_date"
}, " 試験終了日時 ", -1);
const _hoisted_26 = { class: "col-span-8" };
const _hoisted_27 = { class: "w-1/2" };
const _hoisted_28 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "is_auto_calc_result"
}, " 自動集計フラグ ", -1);
const _hoisted_30 = { class: "col-span-8 pt-1.5" };
const _hoisted_31 = { class: "flex items-center" };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("label", {
    for: "is_auto_calc_result",
    class: "text-gray-700"
}, "自動で集計を行うかどうか", -1);
const _hoisted_33 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "price_id"
}, " Stripe価格 ", -1);
const _hoisted_35 = { class: "col-span-8" };
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("div", { class: "text-gray-500 text-sm mt-1" }, "通常価格用", -1);
const _hoisted_37 = { class: "flex items-center mb-10 justify-end px-4 py-3 bg-gray-50 text-right shadow rounded-b-lg" };
const _hoisted_38 = ["disabled"];
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("div", { class: "mr-3 flex-1" }, null, -1);
const _hoisted_40 = ["disabled"];
const _hoisted_41 = {
    key: 0,
    class: "flex mt-10 items-center justify-end px-4 py-3 text-right shadow rounded-lg bg-red-100"
};
const _hoisted_42 = ["disabled"];
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "h-6 w-6 text-red-500",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        "stroke-width": "2"
    }, [
        /*#__PURE__*/ _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("div", { class: "ml-2 text-red-500" }, " 模試を削除してもよろしいですか？ ")
], -1);
const _hoisted_44 = /*#__PURE__*/ _createTextVNode(" キャンセル ");
import { Inertia } from '@inertiajs/inertia';
import { ref } from 'vue';
import AppLayout from '@/Layouts/AppLayout.vue';
import useExamination from '@/types/composables/useExamination';
import VueDatePicker from '@/Common/VueDatePicker.vue';
import useExaminationForm from '@/types/composables/useExaminationForm';
import DialogModal from '@/Common/DialogModal.vue';
import InputError from '@/Jetstream/InputError.vue';
import WhiteButton from '@/Common/Button.vue';
// @ts-ignore
import route from '@/types/Route';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const show = ref(false);
        const { examination, currentExaminationId, currentExaminationType, } = useExamination();
        const initialFormData = {
            id: null,
            title: '',
            is_published: false,
            reception_start: null,
            reception_end: null,
            start_date: null,
            end_date: null,
            is_auto_calc_result: false,
            price_id: null,
            price: null,
        };
        // フォーム管理
        const { form, onFormSubmit } = useExaminationForm(examination, initialFormData, 'examinations.update_examination');
        if (form.price) {
            form.price_id = form.price !== null ? String(form.price) : null;
        }
        // 戻るボタン
        const onReturnClicked = () => {
            Inertia.get(route('examinations', {
                examination: currentExaminationId.value,
                examinationType: currentExaminationType.value,
            }));
        };
        // モーダル表示
        const onDeleteCanceled = () => {
            show.value = !show.value;
        };
        // 削除ボタン
        const onDeletionButtonClicked = () => {
            Inertia.delete(route('examinations.delete_examination', { examinationId: currentExaminationId.value }));
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(AppLayout, { title: "模試編集" }, {
                header: _withCtx(() => [
                    _hoisted_1
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _hoisted_5,
                                _createElementVNode("div", _hoisted_6, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "title",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).title) = $event)),
                                        type: "text",
                                        class: "w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        placeholder: "模試のタイトルを入力してください"
                                    }, null, 512), [
                                        [_vModelText, _unref(form).title]
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.title,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _hoisted_8,
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "is_published",
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).is_published) = $event)),
                                            type: "checkbox",
                                            class: "mr-2"
                                        }, null, 512), [
                                            [_vModelCheckbox, _unref(form).is_published]
                                        ]),
                                        _hoisted_11
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                _hoisted_13,
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _createVNode(VueDatePicker, {
                                            modelValue: _unref(form).reception_start,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).reception_start) = $event)),
                                            placeholder: "受付開始日時を選択",
                                            "min-date": new Date()
                                        }, null, 8, ["modelValue", "min-date"])
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.reception_start,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                                _hoisted_17,
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _createVNode(VueDatePicker, {
                                            modelValue: _unref(form).reception_end,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(form).reception_end) = $event)),
                                            placeholder: "受付終了日時を選択",
                                            "min-date": _unref(form).reception_start || new Date()
                                        }, null, 8, ["modelValue", "min-date"])
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.reception_end,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                                _hoisted_21,
                                _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, [
                                        _createVNode(VueDatePicker, {
                                            modelValue: _unref(form).start_date,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(form).start_date) = $event)),
                                            placeholder: "試験開始日時を選択",
                                            "min-date": new Date()
                                        }, null, 8, ["modelValue", "min-date"])
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.start_date,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                                _hoisted_25,
                                _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                        _createVNode(VueDatePicker, {
                                            modelValue: _unref(form).end_date,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(form).end_date) = $event)),
                                            placeholder: "試験終了日時を選択",
                                            "min-date": _unref(form).start_date || new Date()
                                        }, null, 8, ["modelValue", "min-date"])
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.end_date,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                                _hoisted_29,
                                _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "is_auto_calc_result",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(form).is_auto_calc_result) = $event)),
                                            type: "checkbox",
                                            class: "mr-2"
                                        }, null, 512), [
                                            [_vModelCheckbox, _unref(form).is_auto_calc_result]
                                        ]),
                                        _hoisted_32
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                                _hoisted_34,
                                _createElementVNode("div", _hoisted_35, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "price_id",
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(form).price_id) = $event)),
                                        type: "text",
                                        class: "w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                        placeholder: "通常価格用のStripe価格を入力"
                                    }, null, 512), [
                                        [_vModelText, _unref(form).price_id]
                                    ]),
                                    _hoisted_36,
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.price_id,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass([{ 'opacity-25': _unref(form).processing }, "px-8 py-2 rounded border border-blue-600 text-blue-600 max-w-max shadow-sm hover:shadow-lg"]),
                                disabled: _unref(form).processing,
                                onClick: onReturnClicked
                            }, " 戻る ", 10, _hoisted_38),
                            _hoisted_39,
                            _createElementVNode("button", {
                                class: _normalizeClass([{ 'opacity-25': _unref(form).processing }, "px-8 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg"]),
                                disabled: _unref(form).processing,
                                onClick: _cache[8] || (_cache[8] = _withModifiers(
                                //@ts-ignore
                                (...args) => (_unref(onFormSubmit) && _unref(onFormSubmit)(...args)), ["prevent"]))
                            }, " 更新 ", 10, _hoisted_40)
                        ]),
                        (_unref(currentExaminationId))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                _createElementVNode("button", {
                                    class: _normalizeClass([{ 'opacity-25': _unref(form).processing }, "px-8 py-2 rounded bg-red-700 text-blue-50 max-w-max shadow-sm hover:shadow-lg"]),
                                    disabled: _unref(form).processing,
                                    onClick: _cache[9] || (_cache[9] = _withModifiers(($event) => (show.value = true), ["prevent"]))
                                }, " 削除する ", 10, _hoisted_42)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createVNode(DialogModal, {
                        show: show.value,
                        "max-width": "lg",
                        onClose: onDeleteCanceled
                    }, {
                        title: _withCtx(() => [
                            _hoisted_43
                        ]),
                        footer: _withCtx(() => [
                            _createVNode(WhiteButton, {
                                class: "mr-4 bg-white text-black px-5 py-2 rounded max-w-max shadow-sm",
                                onClick: onDeleteCanceled
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_44
                                ]),
                                _: 1
                            }),
                            _createElementVNode("button", {
                                class: "px-8 py-2 bg-red-600 text-red-50 rounded max-w-max shadow-sm hover:shadow-lg",
                                onClick: onDeletionButtonClicked
                            }, " 削除 ")
                        ]),
                        _: 1
                    }, 8, ["show"])
                ]),
                _: 1
            }));
        };
    }
});
